import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ drawerOrder }: RootState) => drawerOrder;

export const selectDrawerOrder = createSelector(
    selectRoot,
    ({ drawerOrder }) => drawerOrder,
);
